// extracted by mini-css-extract-plugin
module.exports = {"root":"root-5fT_L","icon":"icon-17CsM"};